"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var HorizonLogo = function HorizonLogo(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '221' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '157' : _ref$height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 221 157"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#212121",
    d: "M0 1.38h11.23v60.88h27.19v9.46H0V1.38zM44.52 1.38h11.23v70.33H44.52V1.38zM65.2 36.55C65.2 11.43 72.3 0 88.45 0s23.25 11.43 23.25 36.55-7.09 36.55-23.25 36.55S65.2 61.67 65.2 36.55zm35.27-.3c0-23.64-5.32-27.78-12.02-27.78s-12.02 4.14-12.02 27.78c0 24.23 5.32 28.37 12.02 28.37s12.02-4.14 12.02-28.37zM121.64 1.38h13.69l20.39 52.41h.2V1.38h10.64v70.33h-13.69l-20.39-53.79h-.2v53.79h-10.64V1.38zM186.85 49.94v1.77c0 8.57 3.74 12.91 11.52 12.91 7.09 0 10.64-5.02 10.64-10.25 0-7.39-3.74-10.64-10.05-12.51l-7.68-2.66c-10.24-3.94-14.68-9.26-14.68-19.31 0-12.81 8.67-19.9 21.87-19.9 18.03 0 19.9 11.23 19.9 18.52v1.58h-11.23v-1.48c0-6.4-2.86-10.15-9.85-10.15-4.83 0-9.46 2.66-9.46 10.15 0 6.01 3.05 9.06 10.54 11.92l7.58 2.76c9.95 3.55 14.28 8.96 14.28 18.62 0 14.97-9.06 21.18-23.25 21.18-17.44 0-21.38-11.62-21.38-21.47v-1.68h11.25zM0 86.57h11.23v60.88h27.19v9.46H0V86.57zM44.52 86.57h11.23v70.33H44.52V86.57zM60.48 86.57H72.4l11.92 56.15h.2l12.61-56.15h11.92L91.31 156.9H77.03L60.48 86.57zM114.26 86.57h38.02v9.46h-26.79v19.5h25.22v9.46h-25.22v22.46h27.58v9.46h-38.81V86.57z"
  })));
};

HorizonLogo.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
HorizonLogo.defaultProps = {
  width: '221',
  height: '157'
};
var _default = HorizonLogo;
exports.default = _default;